
import React from 'react';
import { connect } from 'react-redux';
import { Button, Input } from 'reactstrap';
// import ApuaWhiteTextLogo from '../../ImageAssets/ApuaWhiteTextLogo.png';
import ApuaWhiteTextLogo from '../../ImageAssets/Apua_New_Logo.png';
import { FaArrowRight, FaArrowLeft } from 'react-icons/fa';
import Background from '../../ImageAssets/blueskyBackground.png';
import { setLoginPage, setForgetPasswordDetails, setUserRegisterDetails } from '../../General/Actions';
import Swal from 'sweetalert2';
import ValidateForm from '../../Utils/formValidation';
import LoadingAnimation from '../../Utils/loadingAnimation.js';
import Network from '../../Utils/network.js';
import SignUpComponent from './SignUpComponent';
import blueBanner from '../../ImageAssets/blueBanner.png';

class ForgetPasswordComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            serviceId: "",
            siteKey: ""
        }
    }

    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
        // Network.executeAxios("getRecaptchaSiteKey", "GET", "", (resp) => {
        //     this.state.siteKey = resp.SITEKEY
        //     this.setState({
        //         isLoading: false
        //     })
        // });
    }

    updateWindowDimensions = () => {
        this.setState({ windowWidth: window.innerWidth, windowHeight: window.innerHeight });
    }

    inputValueChange(name, value) {
        this.setState({
            [name]: value
        })
    }

    loginButtonClicked = () => {
        this.props.setLoginPage("pageName", "login");
    }

    forgetPasswordProceedBtnClicked() {
        if (ValidateForm.inputFieldMandatoryCheck("forgetPasswordContainer", this.props.locales, false)) {
            if (ValidateForm.inputFieldValueCompositionCheck("forgetPasswordContainer", this.props.locales, false)) {
                var currentService = {}
                this.setState({ isLoading: true })
                Network.executeAxios("fetchServiceInfoForPWL", "POST", { "serviceId": this.state.serviceId }, (fetchServiceInforesponse) => {
                    if (fetchServiceInforesponse && fetchServiceInforesponse.BillingSystem && fetchServiceInforesponse.BillingSystem.response &&
                        fetchServiceInforesponse.BillingSystem.response.dataset && fetchServiceInforesponse.BillingSystem.response.dataset.service_info) {
                        currentService = fetchServiceInforesponse.BillingSystem.response.dataset.service_info[0]
                    }

                    var profileId = ""
                    if (currentService && currentService.profile_id) {
                        profileId = currentService.profile_id
                    }

                   
                    Network.executeAxios("forgetUsername", "POST", { "customerID": profileId }, (forgetUsernameResponse) => {
                        if (forgetUsernameResponse.STATUS === "SUCCESS") {
                            this.props.setForgetPasswordDetails("username", forgetUsernameResponse.USERNAME);
                            this.props.setForgetPasswordDetails("profileID", profileId);
                            if (currentService.profile_info && currentService.profile_info[0]) {
                                var params = currentService.profile_info[0];
                                // var profileContactNumber = "";
                                // if (params && params.contact_number_1) {
                                //     profileContactNumber = params.contact_number_1
                                // }
                                var generatedOtp = Math.floor(Math.random() * 90000) + 10000;
                                var dataToSendForOtp = {
                                    otp: generatedOtp,
                                    contactNum: this.state.serviceId
                                }

                                Network.executeAxios("otpAuth", "POST", dataToSendForOtp, (responseForOtp) => {
                                    if (responseForOtp.result_code && responseForOtp.result_code === "0") {
                                        this.props.setForgetPasswordDetails("profileContactNumber", this.state.serviceId);
                                        this.props.setForgetPasswordDetails("generatedOtp", generatedOtp);
                                        this.props.changeCurrentForgetPasswordPartTo("forgetPasswordOtpSentToNumber");

                                    } else {
                                        Swal.fire(this.props.locales.internalErrorInForgetPwdPageSwal, "", "");
                                        this.setState({ isLoading: false })
                                    }

                                });
                            } else {
                                Swal.fire(this.props.locales.internalErrorInForgetPwdPageSwal, "", "");
                                this.setState({ isLoading: false })
                            }
                        } else if (forgetUsernameResponse.STATUS === "BLOCKED") {
                            Swal.fire(this.props.locales.forgetPswPageBlockedUserSwal, "", "");
                            this.setState({ isLoading: false })
                        } else if (forgetUsernameResponse.STATUS === "USER_NOT_EXIST") {
                            Swal.fire(this.props.locales.forgetPswPageInvalidUserSwal, "", "");
                            this.setState({ isLoading: false })
                        } else if (forgetUsernameResponse.STATUS === "FAILED") {
                            Swal.fire(this.props.locales.forgetPswPageFailedInvalidUserSwal, "", "");
                            this.setState({ isLoading: false })
                        }
                    });
                });
            }
        }
    }

    arrowIconClicked() {
        this.props.setLoginPage("pageName", "login");
    }

    render() {
        return (
            <div>
                <div id="toastPopup" className="animated slideInRight d-none"></div>
                {this.state.isLoading ? <LoadingAnimation isVisible={true} /> : null}
                {this.componentContent()}
            </div>
        )
    }

    componentContent() {
        const forgetPasswordOuterMainContainerStyle = { height: (this.state.windowHeight) + 'px', display: "flex", flexDirection: "column", justifyContent: "space-between" };
        return (
            <div style={forgetPasswordOuterMainContainerStyle}>
                <div className="row m-0" style={{ flex: 1 }}>
                    <div className="col-md-12 p-0" >
                        <div style={{ display: "flex", height: "100%", flex: 1, justifyContent: "center", }}>
                            {this.forgetPasswordPartComponent()}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    forgetPasswordPartComponent() {
        return (
            <div className="loginPageLeftPart col-md-12 row p-0 m-0 pb-5">
                {/* <div className="loginPageLeftPart col-md-12 row p-0 m-0">
                    <div className="d-none d-sm-block d-md-none d-block col-md-12 p-0">
                        <div className="row col-md-12 m-auto py-2 px-2" style={{ backgroundColor: '#0285CA' }}>
                            <div className="col-md-12"><FaArrowLeft color="#fafafa" size="16" onClick={() => this.arrowIconClicked()} /> <img alt="" src={ApuaWhiteTextLogo} height="60" /></div>
                        </div>
                    </div>
                    <div className="col-md-12 row py-4 m-0 my-5 d-none d-sm-block">

                    </div>
                </div> */}
                <div className="col-md-12 p-0 m-0" style={{display:"flex",flex:1,flexDirection:"column"}}>
                    <div className='p-5' style={{  backgroundImage: `url(${blueBanner})`,backgroundRepeat:"no-repeat",backgroundSize:"100% 100%"}}>
                        <div className='pb-5' style={{}}>
                            <img alt="" src={ApuaWhiteTextLogo} />
                        </div>
                    </div>
                    <div className="col-md-12 row m-0 align-items-center justify-content-center">
                        <div className="col-md-3" id="forgetPasswordContainer">
                            <div className="col-md-12" style={{ fontSize: 30, color: '#404042', fontWeight: 400 }}>{this.props.locales.forgetPswpageForgetPswTxt}</div>
                            <div className="col-md-12 pt-2 pr-0" style={{ fontSize: 16, color: '#404042', fontWeight: 600 }}>{this.props.locales.forgetPswUserNameCustomerTxt}</div>
                            <div className="col-md-12" style={{ fontSize: 14, color: '#404042' }}>{this.props.locales.forgetPswUserNameCustomerIDPinTxt} <span style={{ fontWeight: 500 }}>{this.props.locales.forgetPswUserNameNumberTxt}</span></div>
                            <div className="col-md-12 p-0">
                                <div className="form-group col-md-12 pt-4" >
                                    <label className="d-none animated slideInUp m-0" style={{ color: '#a3b4bc', fontSize: 12, position: 'absolute' }}>{this.props.locales.forgetPswPageUserNameTxt}</label>
                                    <Input maxLength={10} type="text" name="serviceId" autoComplete="new-password"
                                        style={{ color: '#404042', fontWeight: 500 }} className="loginCredItem pt-4 pb-3 input_data typeNumber mandatoryFieldSpecial"
                                        placeholder={this.props.locales.forgetPswPageUserNamePlc} onKeyUp={(event) => this.displayLabel(event, this.state.serviceId, this.props.locales.forgetPswPageUserNamePlc)}
                                        onChange={(event) => this.inputValueChange("serviceId", event.target.value)}
                                    />
                                    <div className="errorDesc" style={{ color: 'red', fontSize: 12, fontWeight: 400 }}></div>
                                </div>
                                {/* <div className="col-md-12 pt-3 pb-4">
                                    <Reaptcha sitekey={this.props.siteKey.siteKey} onVerify={this.onVerify} />
                                </div> */}
                                <div className="d-flex col-md-12 pt-3 justify-content-center">
                                    <Button className="loginPageLoginButton align-items-center" onClick={() => { this.forgetPasswordProceedBtnClicked() }} disabled={this.state.serviceId === "" ? true : false}>
                                        {this.props.locales.forgetPswPageProceedBtn}&nbsp; <FaArrowRight />
                                    </Button>
                                </div>
                                <div className="d-flex pt-4 col-md-12 justify-content-center">
                                    <div className='forgetLabel' onClick={() => { this.loginButtonClicked() }}>{this.props.locales.singInOptionTextInSignInWithOtpPart}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    displayLabel(event, value, placeHolderText) {
        if (value !== "") {
            event.target.previousSibling.classList.remove('d-none');
            event.target.placeholder = "";
        } else {
            event.target.previousSibling.classList.add('d-none');
            event.target.placeholder = placeHolderText;
        }
    }

    loginPartComponent() {
        return (
            <div className="loginPageLeftPart col-md-12 p-0 row m-0 pt-5 pb-5" style={{ backgroundColor: '#000000', opacity: 0.7, height: 'inherit', flex: 1 }}>
                <div className="col-md-1"></div>
                <div className="col-md-9 pl-5 pr-4 row pt-5 mt-5" style={{ flex: 1, alignItems: "center", justifyContent: "center", height: 'inherit' }}>
                    <div className="col-md-12 row pt-5" >
                        <div className="mb-1 col-md-12" style={{ fontSize: 32, color: '#ffffff', fontWeight: 300 }}>{this.props.locales.forgetPswPageAlreadyHvAnAccTxt}</div>
                        <div className="mb-5 pb-4 col-md-12" style={{ fontSize: 16, color: '#ffffff', fontWeight: 300 }}>{this.props.locales.forgetPswPageSignInHereTxt}</div>
                        <div className="col-md-12 pr-4">
                            <Button className="loginPageRegisterButton" style={{ fontSize: 24, fontWeight: 500 }} onClick={() => { this.loginButtonClicked() }}>
                                {this.props.locales.forgetPswPageSignInBtn}
                            </Button>
                        </div>
                    </div>
                </div>
                <div className="col-md-2"></div>
            </div>
        )
    }

}
const mapStateToProps = (state, ownProperties) => {
    return {
        locales: state.locales,
        forgetPasswordDetails: state.forgetPasswordDetails,
        siteKey: state.siteKey
    }
}
function mapDispatchToProps(dispatch) {
    return {
        setLoginPage: function (key, payload) {
            dispatch(setLoginPage(key, payload));
        },
        setForgetPasswordDetails: function (key, payload) {
            dispatch(setForgetPasswordDetails(key, payload));
        },
        setUserRegisterDetails: function (key, payload) {
            dispatch(setUserRegisterDetails(key, payload))
        }
    }
}

const ForgetPasswordComponentContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(ForgetPasswordComponent)


export default ForgetPasswordComponentContainer;
